import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { ApiStatus } from '../../api/apiStatus';
import { getOverrideReasons as getOverrideReasonsApi } from '../../api/eventCompleteReasonApi';
import { OverrideReason } from '../../model/override-reason';
import { RootState } from '../store';

export interface OverridesState {
  overrideReasons: OverrideReason[];
  status?: ApiStatus;
  errorMessage?: string;
}

const initialState: OverridesState = {
  overrideReasons: [],
  status: null,
  errorMessage: undefined,
};

export const loadOverrideReasons = createAsyncThunk(
  'overrides/loadOverrideReasons',
  async (payload, { rejectWithValue }) => {
    try {
      return await getOverrideReasonsApi();
    } catch (err: any) {
      return rejectWithValue((err.response as AxiosResponse).data?.message || err.message);
    }
  }
);

export const overridesSlice = createSlice({
  name: 'overrides',
  initialState,
  reducers: {
    reset(state) {
      state.overrideReasons = initialState.overrideReasons;
      state.status = initialState.status;
      state.errorMessage = initialState.errorMessage;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadOverrideReasons.pending, (state) => {
        state.status = 'LOADING';
      })
      .addCase(loadOverrideReasons.fulfilled, (state, action) => {
        state.status = 'SUCCESS';
        state.overrideReasons = [
          ...action.payload.filter((it) => !it.requiresNote),
          ...action.payload.filter((it) => it.requiresNote),
        ];
      })
      .addCase(loadOverrideReasons.rejected, (state, action) => {
        state.status = 'FAILED';
        state.errorMessage = action.payload as string;
      });
  },
});

export const selectOverrideReasons = (state: RootState) => state.overrides.overrideReasons;
export const selectStatus = (state: RootState) => state.overrides.status;
export const selectError = (state: RootState) => state.overrides.errorMessage;
export const { reset } = overridesSlice.actions;
export default overridesSlice.reducer;
